import { defineComponent as _defineComponent } from 'vue'
import { i18n } from '@/assets/i18n';
import { ref } from 'vue';
import { store } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthForm',
  emits: ['onToken', 'onError'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const token = ref('');
const persist = ref(false);

// TODO: very basic validation, update this later
function isValid(token: string): Promise<boolean> {
  return Promise.resolve(token.length > 0);
}

function setToken() {
  isValid(token.value).then((valid) => {
    if (valid) {
      emit('onToken', {
        token: token.value,
        persist: persist.value
      });
    }
  });
}
function togglePersist() {
  if (persist.value) {
    persist.value = false;
  } else {
    const confirm = window.confirm(i18n('AUTH_CONFIRM'));
    window.setTimeout(() => (persist.value = confirm), 1); // hack necessary to set negative answer when user checked checkbox and said no in prompt
  }
}

const __returned__ = { emit, token, persist, isValid, setToken, togglePersist, get i18n() { return i18n }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})